export default "__VITE_ASSET__DXHCunQx__"